module.exports = __webpack_public_path__ + "img/u176.3b36929e.png";